import { Button, Dialog, DialogContent, DialogTitle, IconButton, Skeleton, Stack, Typography } from "@mui/material"
import CloseIcon from '@mui/icons-material/Close';
import { getEOCConfig } from "../../reducer/eocConfigSlice";
import { useEffect, useState } from "react";

import dayjs from 'dayjs';
import buddhistEra from "dayjs/plugin/buddhistEra";
import advancedFormat from "dayjs/plugin/advancedFormat"
import 'dayjs/locale/th';
import { useSelector } from "react-redux";
import { getIAAM } from "../../reducer/iaamSlice";

dayjs.extend(buddhistEra);
dayjs.extend(advancedFormat)
dayjs.locale("th");

dayjs.updateLocale('th', {
    weekStart: 0,
    yearStart: 7
})



export default function EOCDetailDialog(props) {
    const iaam = useSelector(getIAAM);
    const [isLoading, setIsLoading] = useState(false)
    const eocConfig = useSelector(getEOCConfig);
        
    const { open, setOpen, eoc_id } = props

    const [eoc, setEOC] = useState({})
    const [startEOC, setStartEOC] = useState("")
    const [endEOC, setEndEOC] = useState("")
    const [ participating, setParticipating ] = useState({});

    const convertArrayToObject = (array, key) => {
        const initialValue = {};
        return array.reduce((obj, item) => {
          return {
            ...obj,
            [item[key]]: item,
          };
        }, initialValue);
    };

    const getAreaLevelName = (org_level) => {
        switch (org_level) {
            case "01":
                return "ประเทศ"
            case "02":
                return eoc.org_name
            case "03":
                return eoc.province_name
            case "04":
                return eoc.amphur_name
            default:
                return eoc.tambon_name
        }
            
    } 


    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {

        const getEOC = () => {
            iaam.getAccessToken(async (err, access_token) => {
                setIsLoading(true)
                if (!err) {
                    setIsLoading(true);
                    // get the data from the api
                    let options = {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `bearer ${access_token}`
                        }
                    }
                    const resp = await fetch(`${process.env.REACT_APP_API_URL}/my_eoc/get_eoc_by_eoc_id/${eoc_id}?is_history=false`, options);
                    const json = await resp.json();

                    if (json.length > 0) {
                        const eoc = json[0]
                        setEOC(eoc)
                        let start_eoc = dayjs().year(eoc?.start_eoc_year).week(eoc?.start_eoc_week).day(0).format("ww/BBBB")
                        const end_eoc = eoc?.closed_eoc_year ? dayjs().year(eoc.closed_eoc_year).week(eoc.closed_eoc_week).day(0).format("ww/BBBB") : "ปัจจุบัน"
                        setStartEOC(start_eoc)
                        setEndEOC(end_eoc)
                    }
                    setIsLoading(false)
                }
            })
        }

        if (open && eoc_id && eocConfig) {
            getEOC()
            setParticipating(convertArrayToObject(eocConfig.config.participating_org_type, 'po_type_id'))
        }

    }, [open, eoc_id, eocConfig])

    const creatParticipatingOrg = (
        eoc.participating_org?.map((item) => {
            return (
                <div className="flex flex-col px-4 py-2 rounded border" key={item.po_type_id}>
                    <Typography variant='body1' className="col-start-1 col-span-2">{item.po_type_name}</Typography>
                    <Typography variant='button' className="col-start-1 col-span-2 text-gray-600">{participating[item.po_type_id].example ? `เช่น ${participating[item.po_type_id].example.toString().replaceAll(",", " ")}` :"-"}</Typography>
                </div>
            )
        })
    )

    return (
        <Dialog open={open} fullWidth maxWidth="lg">
            <DialogTitle className="py-3">
                รายละเอียดการเปิด EOC
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                })}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent dividers className="md:px-8">
                <div className="w-full grid gap-4 sm:grid-cols-1 md:grid-cols-2">
                    <div className="w-full">
                        {isLoading ? (<Skeleton animation="wave" sx={{ fontSize: '1.5rem', width: '50%' }} />) : (<Typography variant="h6" >EOC ระดับ{eoc?.org_level_name} ({getAreaLevelName(eoc.org_level)})</Typography>)}
                        {isLoading ? (<Skeleton animation="wave" sx={{ fontSize: '1rem', width: '35%' }} />) : (<Typography variant="subtitle2" className="text-[#cd6c4a]">ระหว่างสัปดาห์ที่ {startEOC} - {endEOC}</Typography>)}
                    </div>
                    {/* <div className="w-full flex md:justify-end">
                        {!isLoading && (<Button variant="outlined" className="h-10" color="inherit">ประวัติการเปิด EOC</Button>)}
                    </div> */}
                </div>
                <div className="w-full flex flex-col gap-8 mt-8">
                    <div className="w-full">
                        <Typography variant="subtitle2" className="text-[#cd6c4a]">ผู้บัญชาการเหตุการณ์</Typography>
                        {isLoading ? (<Skeleton animation="wave" sx={{ fontSize: '1.5rem', width: '50%' }} />) : (<Typography variant="body1" >{eoc?.incident_commander?.ic_name}</Typography>)}
                    </div>
                    <div className="w-full md:w-2/3">
                        <Typography variant="subtitle2" className="text-[#cd6c4a] mb-2">เจ้าหน้าที่</Typography>
                        <Stack spacing={2} sx={{ mb: 2 }}>
                            <div className="grid grid-cols-6 gap-4">
                                <Typography variant='body1' className="col-start-1 col-span-2">ชื่อ:</Typography>
                                {isLoading ? (<Skeleton animation="wave" sx={{ fontSize: '1.5rem', width: '50%' }} />) : (<Typography variant="body1" className="col-start-3 col-span-7">{eoc?.creator_name}</Typography>)}
                            </div>
                            <div className="grid grid-cols-6 gap-4">
                                <Typography variant='body1' className="col-start-1 col-span-2">โทรศัพท์:</Typography>
                                {isLoading ? (<Skeleton animation="wave" sx={{ fontSize: '1.5rem', width: '50%' }} />) : (<Typography variant="body1" className="col-start-3 col-span-7">{eoc?.phone}</Typography>)}
                            </div>
                            <div className="grid grid-cols-6 gap-4">
                                <Typography variant='body1' className="col-start-1 col-span-2">E-mail:</Typography>
                                {isLoading ? (<Skeleton animation="wave" sx={{ fontSize: '1.5rem', width: '50%' }} />) : (<Typography variant="body1" className="col-start-3 col-span-7">{eoc?.email}</Typography>)}
                            </div>
                            <div className="grid grid-cols-6 gap-4">
                                <Typography variant='body1' className="col-start-1 col-span-2">หน่วยงาน:</Typography>
                                {isLoading ? (<Skeleton animation="wave" sx={{ fontSize: '1.5rem', width: '50%' }} />) : (<Typography variant="body1" className="col-start-3 col-span-7">{eoc?.org_name}</Typography>)}
                            </div>
                        </Stack>
                    </div>
                    <div className="mb-4">
                        <Typography variant="subtitle2" className="text-[#cd6c4a] mb-2">หน่วยงานที่มีส่วนร่วม</Typography>
                        <div className="w-full grid sm:grid-cols-1 md:grid-cols-3 gap-3">
                            {isLoading ? (
                                <Skeleton variant="rounded" width={210} height={60} />
                            ) : (creatParticipatingOrg)}

                        </div>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    )
}